import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import BadgeIcon from "@mui/icons-material/Badge";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PaidIcon from "@mui/icons-material/Paid";
import PlaceIcon from "@mui/icons-material/Place";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TuneIcon from "@mui/icons-material/Tune";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const REASONS = [
  {
    icon: BadgeIcon,
    title: "Verified teachers",
    description: "Every tutor submits ID proof and qualifications before we send them to a family.",
  },
  {
    icon: TuneIcon,
    title: "Matched to your child",
    description: "We pick on subject, board and temperament — not just on who is nearest.",
  },
  {
    icon: PlaceIcon,
    title: "Across Delhi NCR",
    description: "Tutors who already travel your area, so sessions start on time and stay regular.",
  },
  {
    icon: EventAvailableIcon,
    title: "Your schedule",
    description: "Timings built around school, exams and everything else already in the calendar.",
  },
  {
    icon: PaidIcon,
    title: "Clear fees",
    description: "Agreed before the first class, with no joining charges for parents.",
  },
  {
    icon: SupportAgentIcon,
    title: "A real helpline",
    description: "One number to call if a session needs changing or a match is not working out.",
  },
];

function HomeWhyUs() {
  return (
    <MKBox
      component="section"
      py={{ xs: 5, md: 8 }}
      sx={{ bgcolor: ({ palette: { brand } }) => brand.mist }}
    >
      <Container>
        <MKBox textAlign="center" mb={{ xs: 4, md: 6 }} mx="auto" maxWidth="640px">
          <MKTypography variant="h2" mb={1.5} sx={{ fontSize: { xs: "1.6rem", md: "2.25rem" } }}>
            Why families choose A1
          </MKTypography>
          <MKTypography variant="body2" color="text">
            The things parents tell us made the difference.
          </MKTypography>
        </MKBox>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {REASONS.map(({ icon: Icon, title, description }) => (
            <Grid item xs={12} sm={6} lg={4} key={title}>
              <Stack direction="row" spacing={2} alignItems="flex-start">
                <MKBox
                  sx={{
                    width: 42,
                    height: 42,
                    borderRadius: 2,
                    flexShrink: 0,
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "#fff",
                    border: ({ palette: { brand } }) => `1px solid ${brand.line}`,
                  }}
                >
                  <Icon sx={{ fontSize: 21, color: ({ palette: { brand } }) => brand.navy }} />
                </MKBox>
                <MKBox>
                  <MKTypography variant="h6" mb={0.5} sx={{ fontSize: "1rem" }}>
                    {title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    {description}
                  </MKTypography>
                </MKBox>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default HomeWhyUs;
